<template>
  <!-- <div
    class="iframe-container"
    style="background-color: #1f4e78;"
  >
    <iframe
      width="100%"
      height="2000"
      src="https://www.youtube.com/embed/s2FLYYsvUD0"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      style="border-radius: 0.5%"
    ></iframe>
  </div> -->
  <div style="padding-left: 7%; padding-right: 7%;" class="center pt-5">
    <h1>Do you work on corporate backup care?</h1>
    <div class="center mt-3">
        <h3>We can help you automate the entire process.</h3>
        <h5>If you're curious, we'd love to show you how it works!</h5>
        <p class="center mt-3">1.855.775.4473 | hello@enginehire.ca</p>
      </div>
      <div
        class="meetings-iframe-container mb-5"
        data-src="https://meetings.hubspot.com/zuluaga/schedule-demo?embed=true"
      ></div>
      <!-- https://stackoverflow.com/questions/45047126/how-to-add-external-js-scripts-to-vuejs-components -->
      <script
        type="application/javascript"
        src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
      ></script>
  </div>
</template>

<script>
export default {
  created() {
    // Scroll the window to top on load
    window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
  },
};
</script>

<style>
/* https://www.youtube.com/watch?v=9YffrCViTVk&ab_channel=tipswithpunch */
.iframe-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
}
.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/demovideos/BackupCareAssistant.vue